export const PUBLIC_PATHS = ['/', '/login']
